/**
 * ⚠️⚠️⚠️ DUPLICATED FROM AVP ⚠️⚠️⚠️
 * Mirrored from: `avp/packages/ajax/src/utils.ts` (`getSourceAppId`)
 *
 * ⚠️ Any change here MUST also land in the AVP copy to avoid divergence. ⚠️
 *
 * Reason for duplication:
 *   AVP utilities cannot be imported safely into the Jira SPA. The only
 *   public entrypoint (`@atlassian/viz-platform-views`) is a single barrel
 *   `index.ts`; importing even one helper
 *   would add several MB to the Jira SPA bundle.
 *
 * Per-util notes:
 *   This copy widens the parameter types from `HostingProduct` / `Location`
 *   to `string` (avoids depending on `@avp/types`) and adds a `jsm-cmdb`
 *   case for assets/itam dashboards. Keep the shared branches
 *   (`townsquare`, `jira/*`, `avp`, default) in sync with the AVP source.
 *
 * Long-term resolutions to remove this duplication:
 *   1. Local consumption of individual AVP modules (file-level imports).
 *   2. Add an `exports` map to `@atlassian/viz-platform-views`'s
 *      `package.json` and drop the single-barrel `main`.
 *   3. Create a dedicated `entrypoints/` AVP package exposing only the
 *      minimum utilities required for SPA bootstrap.
 */
export const getSourceAppId = (hostingProduct: string, location?: string | undefined): string => {
	switch (hostingProduct) {
		case 'townsquare':
			return 'platform-dashboard/home';
		case 'jira':
			if (!location) return 'platform-dashboard/home';
			switch (location) {
				case 'jsm-summary':
					return 'platform-dashboard/jsm-summary-page';
				case 'jsw-summary':
					return 'platform-dashboard/jsw-summary-page';
				default:
					return 'platform-dashboard/home';
			}
		case 'avp':
			return 'platform-dashboard/analytics';
		case 'jsm-cmdb':
			return 'platform-dashboard/jsm-assets';
		default:
			return 'platform-dashboard/home';
	}
};
